import { EnvironmentProviders, Provider, inject, provideAppInitializer } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './interceptors/auth.interceptor';
import { AuthService } from './core/services/auth.service';

/**
 * JWT/Bearer-Strategie. Wird per angular.json fileReplacements anstelle von
 * auth-strategy.providers.ts gebaut (Configuration "jwt"), kein Laufzeit-
 * Branching (siehe ADR 0003). Der stille Session-Restore-Call (tryRestoreSession)
 * gehört hierher, damit der Nonce-Build AuthService nie anfasst.
 */
export function provideAuthStrategy(): (Provider | EnvironmentProviders)[] {
  return [
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAppInitializer(() => {
      const authService = inject(AuthService);
      return authService.tryRestoreSession();
    }),
  ];
}
